const  LK_Menu=({color,width,height})=>{
    return(
        <svg id="Layer_1" fill={color} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
            {/* <defs>
                <style>
                .cls-1 {
                    fill: #005c8e;
                    stroke-width: 0px;
                }
                </style>
            </defs> */}
            <path class="cls-1" d="M0,0v17.33c0,4.79,3.88,8.67,8.67,8.67h17.33V0H0ZM21.66,21.66h-13c-2.39,0-4.33-1.94-4.33-4.33V4.33h17.33v17.33ZM0,108.32c0,4.79,3.88,8.67,8.67,8.67h17.33v-26H0v17.33ZM4.33,95.32h17.33v17.33h-13c-2.39,0-4.33-1.94-4.33-4.33v-13ZM0,63.96c0,4.79,3.88,8.67,8.67,8.67h17.33v-26H0v17.33ZM4.33,50.97h17.33v17.33h-13c-2.39,0-4.33-1.94-4.33-4.33v-13ZM116.99,15.16H39v-4.33h77.99v4.33ZM116.99,61.8H39v-4.33h77.99v4.33ZM116.99,106.15H39v-4.33h77.99v4.33Z"/>
        </svg>
    );
};

export default LK_Menu;